var $b152a13832824c4e$exports = {};
$b152a13832824c4e$exports = {
    "more": `\u{305D}\u{306E}\u{4ED6}\u{306E}\u{9805}\u{76EE}`
};


export {$b152a13832824c4e$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
